import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { ISystemAlertActions, ISystemAlertStore, IThunkReadSystemAlert } from '../types';

const onReadSystemAlert: IThunkReadSystemAlert = thunk(
  async (
    { setSystemAlertUpdatesPagination }: Actions<ISystemAlertActions>,
    payload,
    { getState },
  ) => {
    const localState = getState() as ISystemAlertStore;
    await api.systemAlert.readSystemAlert(payload);

    setSystemAlertUpdatesPagination({
      ...localState.systemAlertUpdates.pagination,
      total: localState.systemAlertUpdates.pagination.total - 1,
    });
  },
);

export default onReadSystemAlert;
